import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Button } from "reactstrap";

const propTypes = {
  display: PropTypes.bool.isRequired,
  toggleDisplay: PropTypes.func.isRequired,
  cancelLink: PropTypes.string.isRequired
};

const CancelLinkModal = ({ display, toggleDisplay, cancelLink }) => (
  <Modal
    isOpen={display}
    toggle={toggleDisplay}
    fade={false}
    className="account-app modal-dialog-centered"
  >
    <ModalHeader toggle={toggleDisplay} className="p-2" />
    <ModalBody className="px-4 pt-0 pb-3">
      <p>Customer cancellation link</p>
      <Input type="textarea" rows="5" value={cancelLink} readOnly />
    </ModalBody>
    <ModalFooter>
      <Button onClick={toggleDisplay} color="primary" className="btn-sharp">
        OK
      </Button>
    </ModalFooter>
  </Modal>
);

CancelLinkModal.propTypes = propTypes;

export default CancelLinkModal;
